import { Note } from 'app/agriculture/queries/notes/types/Note';
import { useNotes } from './useNotes';

export function useNote(noteId: string): Note {
    const notes = useNotes();
    const note = notes.get(noteId);

    if (!note) {
        throw new Error(`No fote found for id: ${noteId}`);
    }

    return note;
}
